import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

import {Organism} from './codon-optimization/CodonOptimizationConstants';
import {getDisplayNameForOrganism, ORGANISMS} from './CodonTable/CodonConstants';

interface OrganismSelectorProps {
  className?: string;
  onChange: (organism: Organism | null) => void;
  selected: Organism | null;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const OrganismSelector = (props: OrganismSelectorProps) => (
  <>
    <SelectDropdown
      menu={
        <SearchableMenu
          scrollable={true}
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.FULL}
          selectedValue={props.selected}
          optionDatas={[
            ...[{name: 'None', value: null}],
            ...ORGANISMS.map((organism) => ({
              name: getDisplayNameForOrganism(organism),
              value: organism,
              dataTestAttrs: {component: 'OrganismSelector', element: 'organismOption', key: organism},
            })),
          ]}
          onSelect={props.onChange}
        />
      }
      displayName={props.selected ? getDisplayNameForOrganism(props.selected) : 'None'}
      className={props.className}
      alwaysDropDown={true}
      dataTestAttrs={{component: 'OrganismSelector', element: 'root'}}
    />
  </>
);

export default OrganismSelector;
